import { parseDate } from './parse-date';
import Cookie from '../client-cookie';
import Handlebars from 'handlebars/dist/cjs/handlebars';
const previewBannerHbs = require('html-loader!../../mns-fe-patterns/components/preview-banner/markup.hbs');

const getDateFromCookie = () => {
    let retValue = '';
    const previewDate = Cookie.get('MS_PREVIEW', true);

    if (previewDate) {
        const msPreviewDate = new Date(previewDate.replace('_', 'T'));
        retValue = parseDate(msPreviewDate);
    }
    return retValue;
};

const data = {
    buttonUrl: 'https://preview.marksandspencer.com/MSPreviewCookieSet',
    buttonText: 'Set preview date',
    msgLabel: 'Preview Date:',
    msgText: getDateFromCookie(),
    msgDefaultText: 'No preview date set'
};

const renderPreviewBanner = () => {
    const bodyElement = document.querySelector('body');
    const bannerDiv = document.createElement('div');
    const renderTemplate = Handlebars.compile(previewBannerHbs);
    bannerDiv.innerHTML = renderTemplate(data).trim();
    bodyElement.insertBefore(bannerDiv, bodyElement.firstElementChild);
};

const init = (windowHost = window.location.hostname) => {
    if (windowHost.indexOf('preview.') > -1) {
        renderPreviewBanner();
    }
};

export default {
    init
};



// WEBPACK FOOTER //
// /node_modules/@mands/mns-fe-pattern-library/lib/mns-fe-utilities/preview-banner/index.js